import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IsAuthenticatedResponse } from './userApi.types';

interface AuthData {
  idToken: string;
  isAuthenticated: boolean;
  mustResetPassword: unknown;
  rememberMeSessionId: number;
  requiresTandCAcceptance: boolean;
  sessionId: string;
  userId: number;
}
@Injectable({
  providedIn: 'root',
})
export class UnauthUserApiService {
  baseUrl = '/aptitude/api';

  authenticationBaseUrl = '/aptitude/noauth/api/authentication';
  unsecuredBaseUrl = '/aptitude/noauth/api/useraccount';

  constructor(private http: HttpClient) {}

  authenticate(userName: string, password: string, rememberMe: boolean) {
    return this.http.post<AuthData>(this.authenticationBaseUrl, {
      userName,
      password,
      rememberMe,
    });
  }

  isAuthenticated() {
    return this.http.get(
      this.authenticationBaseUrl,
    ) as Observable<IsAuthenticatedResponse>;
  }

  changePassword(email: string, oldPassword: string, newPassword: string) {
    return this.http.post(`${this.unsecuredBaseUrl}/changepasswordrequests`, {
      email,
      oldPassword,
      newPassword,
    });
  }

  passwordResetRequests(email: string, recaptchaResponse: string) {
    return this.http.post(`${this.unsecuredBaseUrl}/passwordresetrequests`, {
      email,
      recaptchaResponse,
    });
  }

  // This function is the companion to the one above, it is used to actually change the password for a user.
  resetPasswordRequests(securityCode: string, newPassword: string) {
    return this.http.post(`${this.unsecuredBaseUrl}/resetpasswordrequests`, {
      securityCode,
      newPassword,
    });
  }

  isSecurityCodeExpired(securityCode: string) {
    return this.http.get<{ isValid: boolean }>(
      `${this.unsecuredBaseUrl}/securitycodes`,
      {
        params: {
          securityCode,
        },
      },
    );
  }
}
